export default __webpack_public_path__ + "56f558fed7134a906206a505782b1b63.png";